import mapProps from "recompose/mapProps";

const withCanvasPrimary = mapProps(({ primary, ...props }) => ({
  ...props,
  productMuseId: primary.embedCanvasPages.main.productMuseId,
  primary: {
    ...primary.embedCanvasPages.canvas,
    checkWork: primary.embedCanvasPages.checkWork,
    productId: primary.embedCanvasPages.main.productId,
    productHighlights: primary.productHighlights,
    cancelCta: primary.cancelCta,
    drawers: {
      form: primary.embedCanvasPages.form,
      other: primary.embedCanvasPages.canvas.body,
    },
  },
}));

export default withCanvasPrimary;
